import checkout from "./form";

const {
  formField: {
    period,
    exploitationDate,
    firstTime,
    additional,

    taxpayerName,
    dateOfBirth,
    taxId,
    identifier,
    dateRange,
    issuedBy,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    notificationAddress,
    phoneNumber,

    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    plotAddress,
    plotAddressCity,
    plotAddressDistrict,
    plotAddressWard,
    plotAddressVillage,
    plotNumber,
    mapNumber,
    acreage,
    perennialPlant,
    startingTime,
    timeOfAreaChange,

    miningArea,
    catches,
    productSellingPrice,
    valueOfMiningOutput,
    agriculturalLandTax,
    agriculturalLandTaxExemption,
    agriculturalLandUseTax,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [period.name]: "",
  [exploitationDate.name]: "",
  [firstTime.name]: "",
  [additional.name]: "",

  [taxpayerName.name]: "",
  [dateOfBirth.name]: "",
  [taxId.name]: "",
  [identifier.name]: "",
  [dateRange.name]: "",
  [issuedBy.name]: "",
  [city.name]: "",
  [district.name]: "",
  [ward.name]: "",
  [village.name]: "",
  [road.name]: "",
  [apartment.name]: "",
  [notificationAddress.name]: "",
  [phoneNumber.name]: "",

  [taxAgentName.name]: "",
  [taxAgentId.name]: "",
  [taxAgentContract.name]: "",
  [daytaxAgentContract.name]: "",

  [plotAddress.name]: "",
  [plotAddressCity.name]: "",
  [plotAddressDistrict.name]: "",
  [plotAddressWard.name]: "",
  [plotAddressVillage.name]: "",
  [plotNumber.name]: "",
  [mapNumber.name]: "",
  [acreage.name]: "",
  [perennialPlant.name]: "",
  [startingTime.name]: "",
  [timeOfAreaChange.name]: "",

  [miningArea.name]: "",
  [catches.name]: "",
  [productSellingPrice.name]: "",
  [valueOfMiningOutput.name]: "",
  [agriculturalLandTax.name]: "",
  [agriculturalLandTaxExemption.name]: "",
  [agriculturalLandUseTax.name]: "",

  [fullName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};
export default initialValues;
